import Funcs from 'common/helpers/Funcs';
import Const from 'consts/Const';
import Status from 'consts/Status';
import moment from 'moment';
import AntDesign from 'react-native-vector-icons/AntDesign';
import Feather from 'react-native-vector-icons/Feather';
import AppAction from 'states/context/actions/AppAction';
import Configs from 'utils/Configs';
import CN from './langs/CN';
import EN from './langs/EN';
import JP from './langs/JP';
import KR from './langs/KR';
import LO from './langs/LO';
import MM from './langs/MM';
import VI from './langs/VI';

const Lang = {
  change: async () => {
    let language = VI;
    if (Configs.language === 'en') {
      moment.locale('en');
      language = EN;
    } else if (Configs.language === 'ko') {
      require('moment/locale/ko');
      moment.locale('ko');
      language = KR;
    } else if (Configs.language === 'ja') {
      require('moment/locale/ja');
      moment.locale('ja');
      language = JP;
    } else if (Configs.language === 'my') {
      require('moment/locale/my');
      moment.locale('my');
      language = MM;
    } else if (Configs.language === 'lo') {
      moment.locale('en');
      language = LO;
    } else if (Configs.language === 'cn') {
      require('moment/locale/zh-cn');
      moment.locale('zh-cn');
      language = CN;
    } else {
      require('moment/locale/vi');
      moment.locale('vi');
    }
    let keys = Object.keys(language);
    for (var i = 0; i < keys.length; i += 1) {
      let key = keys[i];
      Lang[key] = language[key];
    }

    // Status
    updateOrderStatus();

    // Update state
    AppAction.changeLanguage(Configs.language);
    Funcs.log('Lang change', Configs.language);

    // Promotion
    Const.PROMOTIONS = [
      { name: Lang.promotion.order, value: 0, type: 'order' },
      { name: Lang.promotion.product, value: 1, type: 'product' },
      { name: Lang.promotion.orderGift, value: 2, type: 'ogift' },
      { name: Lang.promotion.productGift, value: 3, type: 'pgift' }
    ];
  },
  ...VI
};

function updateOrderStatus() {
  Status.order = {
    pending: { id: 0, color: '#0000FF', text: Lang.pending, icon: { type: Feather, name: 'clock' } },
    complete: { id: 1, color: '#00CC00', text: Lang.complete, icon: { type: Feather, name: 'check-circle' } },
    canceled: { id: 2, color: '#FF0000', text: Lang.canceled, icon: { type: AntDesign, name: 'closecircleo' } }
  };
}

updateOrderStatus();

// Check key missing
if (__DEV__) {
  let enMissing = [];
  let jpMissing = [];
  let krMissing = [];
  let loMissing = [];
  const allArrayValue = [];
  const vnKeys = Object.keys(VI);
  for (let i = 0; i < vnKeys.length; i += 1) {
    const key = vnKeys[i];
    if (!EN[key] && EN[key] !== '') enMissing.push(key);
    if (!JP[key] && JP[key] !== '') jpMissing.push(key);
    if (!KR[key] && KR[key] !== '') krMissing.push(key);
    if (!LO[key] && LO[key] !== '') loMissing.push(key);
    if (typeof VI[key] === 'object') {
      const vnKeys1 = Object.keys(VI[key]);
      for (let j = 0; j < vnKeys1.length; j += 1) {
        const key1 = vnKeys1[j];
        if (!EN[key] || EN[key][key1] === undefined) enMissing.push(`${key}.${key1}`);
        if (!JP[key] || JP[key][key1] === undefined) jpMissing.push(`${key}.${key1}`);
        if (!KR[key] || KR[key][key1] === undefined) krMissing.push(`${key}.${key1}`);
        if (!LO[key] || LO[key][key1] === undefined) loMissing.push(`${key}.${key1}`);
        allArrayValue.push({ key: key + '.' + key1, value: VI[key][key1] });
      }
    } else {
      allArrayValue.push({ key, value: VI[key] });
    }
  }
  if (enMissing.length > 0) Funcs.log('Missing en keys', enMissing);
  if (jpMissing.length > 0) Funcs.log('Missing jp keys', jpMissing);
  if (krMissing.length > 0) Funcs.log('Missing kr keys', krMissing);
  if (loMissing.length > 0) Funcs.log('Missing lo keys', loMissing);
}

export default Lang;
